<template>
	<widget title="Outbound Document Settings" class="row-padding">
		
		<vue-form v-on:submit="saveInvoiceSettings" :no-top-button="true">

			<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

			<div style="max-width: 500px">
				<form-group label="Accent Color" col-class="col-lg-8 col-md-5 col-sm-8">
					<input type="color" v-model="payload.invoice_accent_color" style="height: 38px;">
				</form-group>

				<field label="Display Revenue Code on Invoice"
					col-class="col-lg-8 col-md-5 col-sm-8"
					:params="{type:'boolean'}"
					v-model="payload.show_revenue_code_on_invoice">
				</field>

				<form-group label="Footer Image" col-class="col-lg-8 col-md-5 col-sm-8">
					<upload-field-with-panel
						api-model="LibraryUpload"
						upload-type="image"
						:value="footerImage"
						v-on:uploaded="imageUploaded">
					</upload-field-with-panel>
					
				</form-group>

				<field label="Footer Image Scale"
					col-class="col-lg-8 col-md-5 col-sm-8"
					:params="{type:'select',options: [
						{text: '25% Page Width',value:0.25},
						{text: '50% Page Width',value:0.50},
						{text: '75% Page Width',value:0.75},
						{text: 'Full Width',value:1},
					]}"
					v-model="payload.invoice_footer_image_scale">
				</field>

				<field label="Default Quote Expiry (days)"
					col-class="col-lg-8 col-md-5 col-sm-8"
					:params="{type:'number'}"
					v-model="payload.quote_expiry_days">
				</field>

			</div>

			<div class="row">
				<div class="col-md-6">
					<field label="WO Summary Fine Print"
						col-class="stacked"
						:params="{type:'richtext'}"
						v-model="payload.wo_summary_terms">

						<div class="text-muted">Default text to appear at the bottom of work order summary documents (above the signature).</div>
					</field>
				</div>
				<div class="col-md-6">
					<field label="Quote Fine Print"
						col-class="stacked"
						:params="{type:'richtext'}"
						v-model="payload.quote_notes">

						<div class="text-muted">Default text to appear at the bottom of quotes. It can be changed at the quote finalizing stage.</div>
					</field>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<field label="Invoice Fine Print"
						col-class="stacked"
						:params="{type:'richtext'}"
						v-model="payload.invoice_notes">

						<div class="text-muted">Default text to appear at the bottom of invoices. It can be changed at the invoice finalizing stage.</div>
					</field>
				</div>
				<div class="col-md-6">
					<field label="Purchase Order Fine Print"
						col-class="stacked"
						:params="{type:'richtext'}"
						v-model="payload.po_terms">

						<div class="text-muted">Default text to appear at the bottom of purchase orders. It can be changed at the PO finalizing stage.</div>
					</field>
				</div>
			</div>

		</vue-form>
	</widget>
</template>
<script type="text/javascript">
import VueForm from "@/components/VueForm"
import Field from "@/components/Field"
import UploadFieldWithPanel from "@/components/super_components/UploadFieldWithPanel"

import Widget from "@/components/Widget"
import FormGroup from "@/components/FormGroup"

import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

export default {
	name: "InvoiceSettings",
	components: {
		Field,
		Widget,
		VueForm,
		FormGroup,
		UploadFieldWithPanel,
		FreemiumLockedAlert
	},
	data() {
		return {
			payload: {
				invoice_notes: "",
				quote_notes: "",
				po_terms: "",
				show_revenue_code_on_invoice: 0,
				wo_summary_terms: "",
				invoice_accent_color: "",
				invoice_footer_image_id: 0,
				quote_expiry_days: 0
			},
			footerImage: null
		}
	},
	watch: {
		'$store.company'() {
			if ("CompanySetting" in this.$store.company) {
				this.setPayload()
				this.fetchFooterImage(this.payload.invoice_footer_image_id)
			}
		}
	},
	methods: {
		setPayload() {
			let settings = this.$store.company.CompanySetting

			this.payload = {
				invoice_notes: settings.invoice_notes,
				show_revenue_code_on_invoice: settings.show_revenue_code_on_invoice,
				quote_notes: settings.quote_notes,
				po_terms: settings.po_terms,
				wo_summary_terms: settings.wo_summary_terms,
				invoice_accent_color: settings.invoice_accent_color,
				invoice_footer_image_id: settings.invoice_footer_image_id,
				invoice_footer_image_scale: settings.invoice_footer_image_scale,
				quote_expiry_days: settings.quote_expiry_days
			}


		},
		imageUploaded(response) {
			this.payload.invoice_footer_image_id = response.data.id
		},
		fetchFooterImage(imageId) {
			let vm = this

			this.getJSON("LibraryUpload/find/"+imageId).then(response => {
				if (response.success)
					vm.footerImage = response.data
			})
		},
		saveInvoiceSettings() {
			let vm = this

			this.postData("CompanySetting/save",this.payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Invoice settings saved!")
					vm.fetchCompanySettings()
				}
			})
		}
	},
	created() {
		if ("CompanySetting" in this.$store.company) {
			this.setPayload()
			this.fetchFooterImage(this.payload.invoice_footer_image_id)
		}
	}
}
</script>